import Teams from "../../../components/teams/Teams";
import Users from "../../../components/users/Users";

const AdminUserPage = () => {

  return (
    <>
      <section>
        <Users />
        <Teams classNames="mt-6"/>
      </section>
    </>
  )
}

export default AdminUserPage;
